import type { SuiteId } from './common';

export enum AdminTabScene {
    ManageGroup = 'manageGroup'
}

export enum AdminTabEventType {
    Refresh = 'refresh'
}

export interface AdminTabPayload {
    suiteId: SuiteId;
    [key: string]: unknown;
}

export interface AdminTabEventBus {
    emit: (
        scene: AdminTabScene,
        eventType: AdminTabEventType,
        payload?: Omit<AdminTabPayload, 'suiteId'>
    ) => void;
    on: (
        scene: AdminTabScene,
        eventType: AdminTabEventType,
        handler: (payload: AdminTabPayload) => void
    ) => () => void;
}
